import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { hasICAMAccess, isAdminManager, isManager } from './roleCheck';

/**
 * Custom hook to access user permissions and role checking functions
 * @param branchId - Optional branch ID to check for specific branch access
 * @returns Object containing user permissions and role checking functions
 */
export const usePermissions = (branchId?: string | null) => {
	const user = useSelector((state: RootState) => state.user);
	const permissions = user.permissions;

	return {
		permissions,
		hasICAMAccess: () => hasICAMAccess(permissions, branchId),
		isAdminManager: () => isAdminManager(permissions),
		isManager: () => isManager(permissions),
	};
};
